<div class="toasts-container">
  <div #toastsContainer></div>
</div>
